import React from "react";
import { Box } from "@mui/material";
import { RendererProps } from "../FilePreviewModal";

const VideoRenderer: React.FC<RendererProps> = ({ blobUrl, fileName }) => {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        backgroundColor: "#000",
      }}
    >
      <video
        src={blobUrl}
        controls
        title={fileName}
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          outline: "none",
        }}
      />
    </Box>
  );
};

export default VideoRenderer;
